




















import {loadMapyCz} from '@/components/maps/mapyCz';
import {IOutput} from 'mapy-cz';
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class MapyCzPanorama extends Vue {
    @Prop({required: true, type: Number})
    public readonly longitude: number;

    @Prop({required: true, type: Number})
    public readonly latitude: number;

    protected panoramaAvailable: boolean = true;

    private apiKey = process.env.VUE_APP_API_KEY_MAPY_CZ;

    private panorama: IOutput | null = null;

    private visibilityTimeout: number | null = null;

    /**
     * Show Panorama when this component is visible for the first time.
     * This makes sure that Mapy.cz SDK detects that this element is visible and has dimensions set.
     * Otherwise, panorama wouldn't load.
     */
    protected visibilityChanged(isVisible: boolean) {
        if (this.visibilityTimeout) {
            clearTimeout(this.visibilityTimeout);
            this.visibilityTimeout = null;
        }

        if (!isVisible && this.panorama !== null) {
            setTimeout(() => {
                this.panorama?.destroy();
                this.panorama = null;
            }, 100);

            return;
        }

        if (!isVisible) {
            return;
        }

        this.visibilityTimeout = window.setTimeout(() => {
            loadMapyCz().then(async (Panorama) => {
                this.panorama = await Panorama.panoramaFromPosition({
                        parent: this.$refs.panorama as HTMLElement,
                        lon: this.longitude,
                        lat: this.latitude,
                        apiKey: this.apiKey,
                        showNavigation: true,
                        yaw: 'point',
                    },
                );
            });

            this.visibilityTimeout = null;
        }, 500);
    }
}
